// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { Link } from "react-router-dom";
// import { api_url } from "../config/config";

// const BlogPage = () => {
//   const [blogs, setBlogs] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [search, setSearch] = useState("");
//   const [selectedCategory, setSelectedCategory] = useState("all");

//   const filteredBlogs = blogs.filter((b) => {
//     const matchesSearch =
//       !search ||
//       b.title?.toLowerCase().includes(search.toLowerCase()) ||
//       b.author?.toLowerCase().includes(search.toLowerCase()) ||
//       b.subtitle?.toLowerCase().includes(search.toLowerCase());

//     const matchesCategory =
//       selectedCategory === "all" ||
//       b.blog_type?.name?.toLowerCase() === selectedCategory.toLowerCase();

//     return matchesSearch && matchesCategory;
//   });

//   useEffect(() => {
//     window.scrollTo(0, 0);
//     axios
//       .get(`${api_url}/blog`)
//       .then((res) => {
//         setBlogs(Array.isArray(res.data?.data) ? res.data.data : []);
//       })
//       .catch((err) => console.error("Error fetching blogs:", err))
//       .finally(() => setLoading(false));
//   }, []);

//   const formatDate = (d) =>
//     new Date(d).toLocaleDateString("en-GB", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//     });

//   const plusPattern = `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='17' y='10' width='6' height='20' rx='2' fill='white'/%3E%3Crect x='10' y='17' width='20' height='6' rx='2' fill='white'/%3E%3C/svg%3E")`;

//   // Extract unique categories
//   const categories = [
//     "all",
//     ...new Set(blogs.map((b) => b.blog_type?.name).filter(Boolean)),
//   ];

//   const latestBlogs = blogs.slice(0, 3);

//   /* ── Skeleton ── */
//   const SkeletonCard = () => (
//     <div className="bg-white rounded-2xl border border-[#e2eaea] overflow-hidden animate-pulse flex flex-col min-h-[340px]">
//       <div className="h-[170px] bg-[#e2eaea] flex-shrink-0" />
//       <div className="p-4 flex flex-col gap-3 flex-1">
//         <div className="h-3 w-16 bg-[#e2eaea] rounded-full" />
//         <div className="h-4 w-4/5 bg-[#e2eaea] rounded-full" />
//         <div className="h-3 w-full bg-[#e2eaea] rounded-full" />
//         <div className="h-3 w-3/4 bg-[#e2eaea] rounded-full" />
//       </div>
//     </div>
//   );

//   /* ── Latest Blog Card ── */
//   const LatestCard = ({ blog, delay = 0 }) => (
//     <Link
//       to={`/blogs/${blog.slug}`}
//       className="group bg-white border-[1.5px] border-[#e2eaea] rounded-2xl overflow-hidden shadow-[0_2px_16px_rgba(22,44,42,0.08)] hover:shadow-[0_12px_36px_rgba(22,44,42,0.18)] hover:border-[#5fbdb3] hover:-translate-y-2 transition-all duration-400"
//       style={{ animation: `fadeInUp 0.4s ease ${delay}ms both` }}
//     >
//       {/* Image */}
//       <div className="relative h-48 overflow-hidden">
//         <img
//           src={blog.blog_images?.[0]?.image_url}
//           alt={blog.title}
//           className="w-full h-full object-cover object-center block group-hover:scale-110 transition-transform duration-500"
//           onError={(e) => {
//             e.target.onerror = null;
//             e.target.src = "/default.svg";
//           }}
//         />
//         <div className="absolute inset-0 bg-gradient-to-t from-[#0a1715]/60 via-transparent to-transparent" />
//         <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-[#5fbdb3] to-[#ff601e] opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
//         {blog.blog_type?.name && (
//           <span className="absolute top-3 left-3 bg-[#1e4a46] text-white text-[9px] font-bold px-2.5 py-1 rounded-full uppercase tracking-wide">
//             {blog.blog_type.name}
//           </span>
//         )}
//         <div className="absolute bottom-3 right-3 flex items-center gap-1 bg-[#0a1715]/70 backdrop-blur-sm rounded-lg px-2 py-1">
//           <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="#5fbdb3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//             <rect x="3" y="4" width="18" height="18" rx="2" />
//             <line x1="16" y1="2" x2="16" y2="6" />
//             <line x1="8" y1="2" x2="8" y2="6" />
//             <line x1="3" y1="10" x2="21" y2="10" />
//           </svg>
//           <span className="text-[9px] font-medium text-white/90">{formatDate(blog.published_at)}</span>
//         </div>
//       </div>

//       {/* Content */}
//       <div className="p-5">
//         <div className="flex items-center gap-2 mb-3">
//           <div className="w-7 h-7 rounded-full bg-[#eaf4f3] border border-[#d4ecea] flex items-center justify-center">
//             <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#1e4a46" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//               <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
//               <circle cx="12" cy="7" r="4" />
//             </svg>
//           </div>
//           <p className="text-[11px] font-semibold text-[#5fbdb3]">{blog.author}</p>
//         </div>
//         <h3 className="font-bold text-[15px] text-[#1e4a46] leading-snug mb-2 group-hover:text-[#ff601e] transition-colors duration-200 line-clamp-2 min-h-[42px]">
//           {blog.title}
//         </h3>
//         {blog.subtitle && (
//           <p className="text-[12px] text-[#607d7b] line-clamp-2 leading-relaxed mb-4">{blog.subtitle}</p>
//         )}
//         <div className="h-px bg-[#f1f5f5] mb-3" />
//         <div className="flex items-center justify-between">
//           {blog.content && (
//             <span className="text-[10px] text-[#8faba9] flex items-center gap-1">
//               <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                 <circle cx="12" cy="12" r="10" />
//                 <polyline points="12 6 12 12 16 14" />
//               </svg>
//               {Math.max(1, Math.ceil(blog.content.length / 200))} min
//             </span>
//           )}
//           <span className="flex items-center gap-1 text-[12px] font-bold text-[#1e4a46] group-hover:text-[#ff601e] transition-colors ml-auto">
//             Read More
//             <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//               <path d="M5 12h14M12 5l7 7-7 7" />
//             </svg>
//           </span>
//         </div>
//       </div>
//     </Link>
//   );

//   /* ── Standard Blog Card (6-per-row, taller, narrower) ── */
//   const BlogCard = ({ blog, delay = 0 }) => (
//     <Link
//       to={`/blogs/${blog.slug}`}
//       className="group bg-white border-[1.5px] border-[#e2eaea] rounded-2xl overflow-hidden shadow-[0_2px_12px_rgba(22,44,42,0.07)] hover:shadow-[0_10px_32px_rgba(22,44,42,0.16)] hover:border-[#5fbdb3] hover:-translate-y-1.5 transition-all duration-300 flex flex-col min-h-[340px]"
//       style={{ animation: `fadeInUp 0.35s ease ${delay}ms both` }}
//     >
//       {/* Image — fixed height, proper cover */}
//       <div className="relative h-[170px] overflow-hidden flex-shrink-0">
//         <img
//           src={blog.blog_images?.[0]?.image_url}
//           alt={blog.title}
//           className="w-full h-full object-cover object-center block group-hover:scale-105 transition-transform duration-500"
//           onError={(e) => {
//             e.target.onerror = null;
//             e.target.src = "/default.svg";
//           }}
//         />
//         <div className="absolute inset-0 bg-gradient-to-t from-[#0a1715]/55 via-transparent to-transparent" />
//         <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-[#162c2a] via-[#5fbdb3] to-[#ff601e] opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
//         {blog.blog_type?.name && (
//           <span className="absolute top-2.5 left-2.5 bg-[#ff601e] text-white text-[9px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wide shadow-[0_2px_6px_rgba(255,96,30,0.4)]">
//             {blog.blog_type.name}
//           </span>
//         )}
//         <div className="absolute bottom-2.5 right-2.5 flex items-center gap-1 bg-[#0a1715]/70 backdrop-blur-sm rounded-lg px-2 py-0.5">
//           <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="#5fbdb3" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//             <rect x="3" y="4" width="18" height="18" rx="2" />
//             <line x1="16" y1="2" x2="16" y2="6" />
//             <line x1="8" y1="2" x2="8" y2="6" />
//             <line x1="3" y1="10" x2="21" y2="10" />
//           </svg>
//           <span className="text-[9px] font-medium text-white/80">{formatDate(blog.published_at)}</span>
//         </div>
//       </div>

//       {/* Content */}
//       <div className="p-4 flex flex-col gap-2 flex-1">
//         <div className="flex items-center gap-1.5">
//           <div className="w-5 h-5 rounded-full bg-[#1e4a46] flex items-center justify-center flex-shrink-0">
//             <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//               <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
//               <circle cx="12" cy="7" r="4" />
//             </svg>
//           </div>
//           <p className="text-[10px] font-semibold text-[#5fbdb3] truncate">{blog.author}</p>
//         </div>

//         <h3 className="font-bold text-[13px] text-[#1e4a46] leading-snug group-hover:text-[#ff601e] transition-colors duration-200 line-clamp-2 flex-1">
//           {blog.title}
//         </h3>

//         {blog.subtitle && (
//           <p className="text-[11px] text-[#607d7b] line-clamp-2 leading-relaxed">{blog.subtitle}</p>
//         )}

//         <div className="w-full h-px bg-[#f1f5f5] mt-auto" />

//         <div className="flex items-center justify-between pt-1">
//           {blog.content && (
//             <span className="text-[10px] text-[#8faba9]">
//               {Math.max(1, Math.ceil(blog.content.length / 200))} min read
//             </span>
//           )}
//           <span className="flex items-center gap-0.5 text-[11px] font-bold text-[#1e4a46] group-hover:text-[#ff601e] transition-colors ml-auto">
//             Read
//             <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//               <path d="M5 12h14M12 5l7 7-7 7" />
//             </svg>
//           </span>
//         </div>
//       </div>
//     </Link>
//   );

//   return (
//     <div className="min-h-screen bg-[#f8fafa] font-poppins">
//       {/* ══════════════════════════════════════════════
//           HERO BANNER
//       ══════════════════════════════════════════════ */}
//       <div
//         className="relative w-full overflow-hidden"
//         style={{ background: "linear-gradient(135deg, #0a1715 0%, #162c2a 50%, #1e4a46 100%)" }}
//       >
//         <div
//           className="absolute inset-0 opacity-[0.04] pointer-events-none"
//           style={{ backgroundImage: plusPattern, backgroundRepeat: "repeat", backgroundSize: "40px 40px" }}
//         />
//         <div className="absolute -top-16 right-0 w-96 h-96 rounded-full bg-[#5fbdb3]/10 blur-3xl pointer-events-none" />
//         <div className="absolute bottom-0 left-1/4 w-64 h-64 rounded-full bg-[#ff601e]/8 blur-3xl pointer-events-none" />

//         <div className="relative px-5 sm:px-8 lg:px-14 py-12 sm:py-16 sm:mt-0 mt-36">
//           {/* Breadcrumb */}
//           <nav className="flex items-center gap-2 text-[12px] text-white/40 mb-6 font-medium">
//             <Link to="/home" className="hover:text-white/70 transition-colors">Home</Link>
//             <svg width="10" height="10" viewBox="0 0 16 16" fill="none">
//               <path d="M6 12l4-4-4-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
//             </svg>
//             <span className="text-white font-bold">Wellness Guide</span>
//           </nav>

//           <div className="flex items-center gap-3 mb-4">
//             <span className="w-6 h-[2px] bg-[#ff601e] rounded-full" />
//             <span className="text-[11px] font-semibold uppercase tracking-widest text-[#5fbdb3]">
//               Health &amp; Wellness Blog
//             </span>
//           </div>

//           <h1 className="font-black text-[32px] sm:text-[42px] lg:text-[52px] text-white leading-[1.1] mb-4 max-w-[680px]">
//             Expert Health Insights &amp;{" "}
//             <span className="text-[#5fbdb3]">Wellness Tips</span>
//           </h1>

//           <p className="text-[14px] sm:text-[15px] text-white/60 leading-relaxed max-w-[520px] mb-8">
//             Discover trusted health advice, expert tips, and the latest wellness trends from our team of healthcare professionals.
//           </p>

//           {/* Search + Stats */}
//           <div className="flex flex-col lg:flex-row gap-4 max-w-5xl">
//             {/* Search */}
//             <div className="flex items-center gap-2 bg-white/[0.09] border border-white/[0.15] rounded-xl px-4 h-12 flex-1 focus-within:bg-white/[0.13] focus-within:border-[#5fbdb3]/60 transition-all duration-200">
//               <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#5fbdb3" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="flex-shrink-0">
//                 <circle cx="11" cy="11" r="8" />
//                 <line x1="21" y1="21" x2="16.65" y2="16.65" />
//               </svg>
//               <input
//                 type="text"
//                 placeholder="Search articles by title, author, topic…"
//                 value={search}
//                 onChange={(e) => setSearch(e.target.value)}
//                 className="flex-1 bg-transparent outline-none text-[13px] text-white placeholder-white/35"
//               />
//               {search && (
//                 <button onClick={() => setSearch("")} className="text-white/40 hover:text-white text-xl leading-none transition-colors">×</button>
//               )}
//             </div>

//             {/* Stats Pills */}
//             <div className="flex items-center gap-3 flex-wrap">
//               <div className="flex items-center gap-2.5 bg-white/[0.07] border border-white/[0.12] rounded-xl px-4 py-2.5">
//                 <div className="w-9 h-9 rounded-lg border border-[#5fbdb3]/40 bg-[#5fbdb3]/10 flex items-center justify-center flex-shrink-0">
//                   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#5fbdb3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                     <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
//                     <polyline points="14 2 14 8 20 8" />
//                     <line x1="16" y1="13" x2="8" y2="13" />
//                     <line x1="16" y1="17" x2="8" y2="17" />
//                   </svg>
//                 </div>
//                 <div>
//                   <p className="font-bold text-[16px] text-white leading-none">{loading ? "—" : `${blogs.length}+`}</p>
//                   <p className="text-[10px] text-white/40 mt-0.5">Articles</p>
//                 </div>
//               </div>

//               <div className="flex items-center gap-2.5 bg-white/[0.07] border border-white/[0.12] rounded-xl px-4 py-2.5">
//                 <div className="w-9 h-9 rounded-lg border border-[#ff601e]/40 bg-[#ff601e]/10 flex items-center justify-center flex-shrink-0">
//                   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ff601e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                     <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
//                   </svg>
//                 </div>
//                 <div>
//                   <p className="font-bold text-[16px] text-white leading-none">{categories.length - 1}+</p>
//                   <p className="text-[10px] text-white/40 mt-0.5">Topics</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="absolute bottom-0 left-0 right-0 h-8 bg-gradient-to-t from-[#f8fafa] to-transparent" />
//       </div>

//       <div className="px-5 sm:px-8 lg:px-14 py-10">
// {/*
//         {!loading && latestBlogs.length > 0 && !search && selectedCategory === "all" && (
//           <div className="mb-12">
//             <div className="flex items-center gap-3 mb-6">
//               <span className="w-5 h-[2px] bg-[#5fbdb3] rounded-full" />
//               <h2 className="font-bold text-[20px] sm:text-[22px] text-[#1e4a46]">Latest Articles</h2>
//               <div className="flex-1 h-px bg-[#e2eaea]" />
//             </div>
//             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//               {latestBlogs.map((blog, i) => (
//                 <LatestCard key={blog.id} blog={blog} delay={i * 80} />
//               ))}
//             </div>
//           </div>
//         )} */}

//         {/* ══════════════════════════════════════════════
//             CATEGORY FILTERS
//         ══════════════════════════════════════════════ */}
//         {!loading && categories.length > 1 && (
//           <div className="mb-8">
//             <div className="flex items-center gap-3 overflow-x-auto scrollbar-hide pb-2">
//               {categories.map((cat) => (
//                 <button
//                   key={cat}
//                   onClick={() => setSelectedCategory(cat)}
//                   className={`flex-shrink-0 px-5 py-2 rounded-xl text-[12px] font-bold transition-all duration-200 border-[1.5px] ${
//                     selectedCategory === cat
//                       ? "bg-[#1e4a46] text-white border-[#1e4a46] shadow-[0_4px_12px_rgba(30,74,70,0.3)]"
//                       : "bg-white text-[#374747] border-[#e2eaea] hover:border-[#5fbdb3] hover:text-[#1e4a46]"
//                   }`}
//                 >
//                   {cat === "all" ? "All Articles" : cat}
//                 </button>
//               ))}
//             </div>
//           </div>
//         )}

//         {/* ══════════════════════════════════════════════
//             ALL BLOGS GRID — 6 per row
//         ══════════════════════════════════════════════ */}
//         <div>
//           <div className="flex items-center gap-3 mb-6">
//             <span className="w-5 h-[2px] bg-[#1e4a46] rounded-full" />
//             <h2 className="font-bold text-[18px] sm:text-[20px] text-[#1e4a46]">
//               {search
//                 ? `Search Results for "${search}"`
//                 : selectedCategory !== "all"
//                 ? `${selectedCategory} Articles`
//                 : "All Articles"}
//             </h2>
//             <div className="flex-1 h-px bg-[#e2eaea]" />
//             {!loading && (
//               <span className="text-[12px] font-medium text-[#8faba9] bg-[#eaf4f3] border border-[#d4ecea] rounded-full px-3 py-1">
//                 {filteredBlogs.length} article{filteredBlogs.length !== 1 ? "s" : ""}
//               </span>
//             )}
//           </div>

//           {/* ← KEY CHANGE: 6 columns at xl, graceful fallback at smaller screens */}
//           <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4">
//             {loading
//               ? Array.from({ length: 12 }).map((_, i) => <SkeletonCard key={i} />)
//               : filteredBlogs.map((blog, i) => (
//                   <BlogCard key={blog.id} blog={blog} delay={i * 50} />
//                 ))}
//           </div>

//           {/* Empty state */}
//           {!loading && filteredBlogs.length === 0 && (
//             <div className="flex flex-col items-center justify-center py-24 gap-5">
//               <div className="w-20 h-20 rounded-2xl bg-[#eaf4f3] border border-[#d4ecea] flex items-center justify-center">
//                 <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#5fbdb3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
//                   <circle cx="11" cy="11" r="8" />
//                   <line x1="21" y1="21" x2="16.65" y2="16.65" />
//                 </svg>
//               </div>
//               <div className="text-center">
//                 <p className="font-bold text-[18px] text-[#1e4a46] mb-2">No articles found</p>
//                 <p className="text-[13px] text-[#8faba9] max-w-[320px]">
//                   {search
//                     ? "Try adjusting your search terms or browse all articles"
//                     : "Check back soon for new health tips and guides"}
//                 </p>
//               </div>
//               {search && (
//                 <button
//                   onClick={() => { setSearch(""); setSelectedCategory("all"); }}
//                   className="flex items-center gap-2 bg-[#1e4a46] hover:bg-[#ff601e] text-white font-bold text-[13px] px-6 py-2.5 rounded-xl transition-all duration-200 border-none shadow-lg"
//                 >
//                   <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//                     <polyline points="1 4 1 10 7 10" />
//                     <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" />
//                   </svg>
//                   Clear Search
//                 </button>
//               )}
//             </div>
//           )}
//         </div>
//       </div>

//       {/* ── Inline animation styles ── */}
//       <style>{`
//         @keyframes fadeInUp {
//           from { opacity: 0; transform: translateY(20px); }
//           to   { opacity: 1; transform: translateY(0); }
//         }
//         .scrollbar-hide::-webkit-scrollbar { display: none; }
//         .scrollbar-hide { -ms-overflow-style: none; scrollbar-width: none; }
//       `}</style>
//     </div>
//   );
// };

// export default BlogPage;
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { api_url } from "../config/config";

const BlogPage = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("all");

  const filteredBlogs = blogs.filter((b) => {
    const matchesSearch =
      !search ||
      b.title?.toLowerCase().includes(search.toLowerCase()) ||
      b.author?.toLowerCase().includes(search.toLowerCase()) ||
      b.subtitle?.toLowerCase().includes(search.toLowerCase());
    const matchesCategory =
      selectedCategory === "all" ||
      b.blog_type?.name?.toLowerCase() === selectedCategory.toLowerCase();
    return matchesSearch && matchesCategory;
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    axios
      .get(`${api_url}/blog`)
      .then((res) =>
        setBlogs(Array.isArray(res.data?.data) ? res.data.data : []),
      )
      .catch((err) => console.error("Error fetching blogs:", err))
      .finally(() => setLoading(false));
  }, []);

  const formatDate = (d) =>
    new Date(d).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

  const plusPattern = `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='17' y='10' width='6' height='20' rx='2' fill='white'/%3E%3Crect x='10' y='17' width='20' height='6' rx='2' fill='white'/%3E%3C/svg%3E")`;

  const categories = [
    "all",
    ...new Set(blogs.map((b) => b.blog_type?.name).filter(Boolean)),
  ];

  /* ── Skeleton ── */
  const SkeletonCard = () => (
    <div className="bg-white rounded-2xl border border-[#e2eaea] overflow-hidden animate-pulse flex flex-col">
      <div className="h-[220px] bg-[#e2eaea] flex-shrink-0" />
      <div className="p-5 flex flex-col gap-3 flex-1">
        <div className="h-3 w-20 bg-[#e2eaea] rounded-full" />
        <div className="h-5 w-4/5 bg-[#e2eaea] rounded-full" />
        <div className="h-3 w-full bg-[#e2eaea] rounded-full" />
        <div className="h-3 w-3/4 bg-[#e2eaea] rounded-full" />
        <div className="h-3 w-2/3 bg-[#e2eaea] rounded-full" />
      </div>
    </div>
  );

  /* ── Blog Card — 4-per-row, wide + tall ── */
  const BlogCard = ({ blog, index = 0 }) => {
    const isOrange = index % 2 === 1;
    return (
      <Link
        to={`/blogs/${blog.slug}`}
        className={`group bg-white border-[1.5px] ${isOrange ? "border-[#ffd5c2] hover:border-[#ff601e]" : "border-[#c8d8d7] hover:border-[#5fbdb3]"} rounded-2xl overflow-hidden hover:-translate-y-2 transition-all duration-300 flex flex-col`}
        style={{
          textDecoration: "none",
          animation: `fadeInUp 0.35s ease ${(index % 8) * 55}ms both`,
          boxShadow: isOrange
            ? "0 2px 14px rgba(255,96,30,0.09)"
            : "0 2px 14px rgba(95,189,179,0.09)",
        }}
      >
        {/* ── Image ── */}
        <div className="relative h-[220px] sm:h-[240px] overflow-hidden flex-shrink-0">
          <img
            src={blog.blog_images?.[0]?.image_url}
            alt={blog.title}
            className="w-full h-full object-cover object-center block group-hover:scale-108 transition-transform duration-500"
            style={{ transform: "scale(1)" }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.transform = "scale(1.07)")
            }
            onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/default.svg";
            }}
          />

          {/* Dark gradient overlay */}
          <div className="absolute inset-0 bg-gradient-to-t from-[#0a1715]/65 via-[#0a1715]/10 to-transparent" />

          {/* Top accent bar on hover */}
          <div
            className={`absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r ${isOrange ? "from-[#ff601e] to-[#e55519]" : "from-[#1e4a46] via-[#5fbdb3] to-[#1e4a46]"} opacity-0 group-hover:opacity-100 transition-opacity duration-300`}
          />

          {/* Category badge */}
          {blog.blog_type?.name && (
            <span
              className={`absolute top-3.5 left-3.5 ${isOrange ? "bg-[#ff601e]" : "bg-[#1e4a46]"} text-white text-[10px] font-bold px-2.5 py-1 rounded-full uppercase tracking-wide`}
              style={{
                boxShadow: isOrange
                  ? "0 2px 8px rgba(255,96,30,0.4)"
                  : "0 2px 8px rgba(22,44,42,0.3)",
              }}
            >
              {blog.blog_type.name}
            </span>
          )}

          {/* Date chip bottom-right */}
          <div className="absolute bottom-3 right-3 flex items-center gap-1.5 bg-[#0a1715]/75 backdrop-blur-sm rounded-lg px-2.5 py-1">
            <svg
              width="9"
              height="9"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#5fbdb3"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect x="3" y="4" width="18" height="18" rx="2" />
              <line x1="16" y1="2" x2="16" y2="6" />
              <line x1="8" y1="2" x2="8" y2="6" />
              <line x1="3" y1="10" x2="21" y2="10" />
            </svg>
            <span className="text-[10px] font-medium text-white/85">
              {formatDate(blog.published_at)}
            </span>
          </div>

          {/* Read-time chip bottom-left */}
          {blog.content && (
            <div className="absolute bottom-3 left-3 flex items-center gap-1 bg-[#0a1715]/75 backdrop-blur-sm rounded-lg px-2.5 py-1">
              <svg
                width="9"
                height="9"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#5fbdb3"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="12" cy="12" r="10" />
                <polyline points="12 6 12 12 16 14" />
              </svg>
              <span className="text-[10px] font-medium text-white/85">
                {Math.max(1, Math.ceil(blog.content.length / 200))} min
              </span>
            </div>
          )}
        </div>

        {/* ── Content body ── */}
        <div className="p-5 flex flex-col gap-3 flex-1">
          {/* Author row */}
          <div className="flex items-center gap-2">
            <div
              className={`w-6 h-6 rounded-full ${isOrange ? "bg-[#fff3ee] border border-[#ffd5c2]" : "bg-[#ddf0ee] border border-[#aac9c7]"} flex items-center justify-center flex-shrink-0`}
            >
              <svg
                width="11"
                height="11"
                viewBox="0 0 24 24"
                fill="none"
                stroke={isOrange ? "#ff601e" : "#1e4a46"}
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
            </div>
            <p
              className={`text-[12px] font-bold truncate ${isOrange ? "text-[#ff601e]" : "text-[#5fbdb3]"}`}
            >
              {blog.author || "Health Team"}
            </p>
          </div>

          {/* Title */}
          <h3
            className="font-black text-[14px] sm:text-[16px] text-[#1e3330] leading-snug group-hover:text-[#1e4a46] transition-colors duration-200 line-clamp-2"
            style={{ fontFamily: "'Nunito',sans-serif" }}
          >
            {blog.title}
          </h3>

          {/* Subtitle */}
          {blog.subtitle && (
            <p className="text-[13px] text-[#5a7a77] line-clamp-2 leading-relaxed flex-1">
              {blog.subtitle}
            </p>
          )}

          {/* Divider */}
          <div className="h-px bg-[#e8f5f4] mt-auto" />

          {/* Footer */}
          <div className="flex items-center justify-between pt-1">
            <span
              className={`text-[10.5px] font-semibold px-2.5 py-1 rounded-full border ${isOrange ? "bg-[#fff3ee] text-[#ff601e] border-[#ffd5c2]" : "bg-[#f2f8f7] text-[#2d5250] border-[#c8d8d7]"}`}
            >
              {blog.blog_type?.name || "Article"}
            </span>
            <span
              className={`flex items-center gap-1 text-[12px] font-bold transition-colors ${isOrange ? "text-[#ff601e] group-hover:text-[#e55519]" : "text-[#1e4a46] group-hover:text-[#ff601e]"}`}
            >
              Read More
              <svg
                width="11"
                height="11"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </span>
          </div>
        </div>
      </Link>
    );
  };

  /* ════════════════════════════════════════════════════════════ */
  return (
    <div className="min-h-screen bg-[#f2f8f7] font-poppins">
      <div
        className="relative w-full overflow-hidden"
        style={{
          background:
            "linear-gradient(135deg, #0a1715 0%, #162c2a 50%, #1e4a46 100%)",
        }}
      >
        <div
          className="absolute inset-0 opacity-[0.04] pointer-events-none"
          style={{
            backgroundImage: plusPattern,
            backgroundRepeat: "repeat",
            backgroundSize: "40px 40px",
          }}
        />
        <div className="absolute -top-16 right-0 w-96 h-96 rounded-full bg-[#5fbdb3]/10 blur-3xl pointer-events-none" />
        <div className="absolute bottom-0 left-1/4 w-64 h-64 rounded-full bg-[#ff601e]/8 blur-3xl pointer-events-none" />

        <div className="relative px-5 sm:px-8 lg:px-14 py-12 sm:py-16 sm:mt-0 mt-36">
          {/* Breadcrumb */}
          <nav className="flex items-center gap-2 text-[12px] text-white/40 mb-6 font-medium">
            <Link to="/home" className="hover:text-white/70 transition-colors">
              Home
            </Link>
            <svg width="10" height="10" viewBox="0 0 16 16" fill="none">
              <path
                d="M6 12l4-4-4-4"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className="text-white font-bold">Wellness Guide</span>
          </nav>

          <div className="flex items-center gap-3 mb-4">
            <span className="w-6 h-[2px] bg-[#ff601e] rounded-full" />
            <span className="text-[11px] font-semibold uppercase tracking-widest text-[#5fbdb3]">
              Health &amp; Wellness Blog
            </span>
          </div>

          <h1 className="font-black text-[32px] sm:text-[42px] lg:text-[52px] text-white leading-[1.1] mb-4 max-w-[680px]">
            Expert Health Insights &amp;{" "}
            <span className="text-[#5fbdb3]">Wellness Tips</span>
          </h1>

          <p className="text-[14px] sm:text-[15px] text-white/60 leading-relaxed max-w-[520px] mb-8">
            Discover trusted health advice, expert tips, and the latest wellness
            trends from our team of healthcare professionals.
          </p>

          {/* Search + Stats */}
          <div className="flex flex-col lg:flex-row gap-4 max-w-5xl">
            <div className="flex items-center gap-2 bg-white/[0.09] border border-white/[0.15] rounded-xl px-4 h-12 flex-1 focus-within:bg-white/[0.13] focus-within:border-[#5fbdb3]/60 transition-all duration-200">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#5fbdb3"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="flex-shrink-0"
              >
                <circle cx="11" cy="11" r="8" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
              <input
                type="text"
                placeholder="Search articles by title, author, topic…"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="flex-1 bg-transparent outline-none text-[13px] text-white placeholder-white/35"
              />
              {search && (
                <button
                  onClick={() => setSearch("")}
                  className="text-white/40 hover:text-white text-xl leading-none transition-colors cursor-pointer"
                >
                  ×
                </button>
              )}
            </div>

            <div className="flex items-center gap-3 flex-wrap">
              {[
                {
                  icon: (
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#5fbdb3"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                      <polyline points="14 2 14 8 20 8" />
                      <line x1="16" y1="13" x2="8" y2="13" />
                      <line x1="16" y1="17" x2="8" y2="17" />
                    </svg>
                  ),
                  color: "#5fbdb3",
                  val: loading ? "—" : `${blogs.length}+`,
                  label: "Articles",
                },
                {
                  icon: (
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#ff601e"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
                    </svg>
                  ),
                  color: "#ff601e",
                  val: `${categories.length - 1}+`,
                  label: "Topics",
                },
              ].map((s, i) => (
                <div
                  key={i}
                  className="flex items-center gap-2.5 bg-white/[0.07] border border-white/[0.12] rounded-xl px-4 py-2.5"
                >
                  <div
                    className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0"
                    style={{
                      border: `1px solid ${s.color}40`,
                      background: `${s.color}18`,
                    }}
                  >
                    {s.icon}
                  </div>
                  <div>
                    <p className="font-bold text-[16px] text-white leading-none">
                      {s.val}
                    </p>
                    <p className="text-[10px] text-white/40 mt-0.5">
                      {s.label}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-8 bg-gradient-to-t from-[#f2f8f7] to-transparent" />
      </div>

      {/* ══ MAIN CONTENT ══ */}
      <div className="px-5 sm:px-8 lg:px-14 py-10">
        {/* ── Category filters ── */}
        {!loading && categories.length > 1 && (
          <div className="mb-8">
            <div className="flex items-center gap-2.5 overflow-x-auto scrollbar-hide pb-2">
              {categories.map((cat) => (
                <button
                  key={cat}
                  onClick={() => setSelectedCategory(cat)}
                  className={`flex-shrink-0 px-5 py-2 rounded-xl text-[14px] font-bold transition-all duration-200 border-[1.5px] cursor-pointer ${
                    selectedCategory === cat
                      ? "bg-[#1e4a46] text-white border-[#1e4a46]"
                      : "bg-white text-[#1e3330] border-[#c8d8d7] hover:border-[#5fbdb3] hover:text-[#1e4a46]"
                  }`}
                  style={
                    selectedCategory === cat
                      ? { boxShadow: "0 4px 12px rgba(30,74,70,0.25)" }
                      : {}
                  }
                >
                  {cat === "all" ? "All Articles" : cat}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* ── Section heading ── */}
        <div className="flex items-center gap-3 mb-7">
          <span className="w-5 h-[2px] bg-[#ff601e] rounded-full" />
          <h2 className="font-bold text-[18px] sm:text-[20px] text-[#1e4a46]">
            {search
              ? `Results for "${search}"`
              : selectedCategory !== "all"
                ? `${selectedCategory} Articles`
                : "All Articles"}
          </h2>
          <div className="flex-1 h-px bg-[#c8d8d7]" />
          {!loading && (
            <span className="text-[12px] font-bold text-[#1e4a46] bg-[#ddf0ee] border border-[#aac9c7] rounded-full px-3 py-1">
              {filteredBlogs.length} article
              {filteredBlogs.length !== 1 ? "s" : ""}
            </span>
          )}
        </div>

        {/* ══ GRID — 4 per row max ══ */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {loading
            ? Array.from({ length: 8 }).map((_, i) => <SkeletonCard key={i} />)
            : filteredBlogs.map((blog, i) => (
                <BlogCard key={blog.id || i} blog={blog} index={i} />
              ))}
        </div>

        {/* ── Empty state ── */}
        {!loading && filteredBlogs.length === 0 && (
          <div className="flex flex-col items-center justify-center py-24 gap-5">
            <div className="w-20 h-20 rounded-2xl bg-[#ddf0ee] border border-[#aac9c7] flex items-center justify-center">
              <svg
                width="36"
                height="36"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#5fbdb3"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="11" cy="11" r="8" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
            </div>
            <div className="text-center">
              <p className="font-bold text-[18px] text-[#1e4a46] mb-2">
                No articles found
              </p>
              <p className="text-[13px] text-[#5a7a77] max-w-[320px]">
                {search
                  ? "Try adjusting your search or browse all articles"
                  : "Check back soon for new health tips and guides"}
              </p>
            </div>
            {search && (
              <button
                onClick={() => {
                  setSearch("");
                  setSelectedCategory("all");
                }}
                className="flex items-center gap-2 bg-[#1e4a46] hover:bg-[#ff601e] text-white font-bold text-[13px] px-6 py-2.5 rounded-xl transition-all duration-200 border-none cursor-pointer"
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="1 4 1 10 7 10" />
                  <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" />
                </svg>
                Clear Search
              </button>
            )}
          </div>
        )}
      </div>

      <style>{`
        @keyframes fadeInUp {
          from { opacity:0; transform:translateY(18px); }
          to   { opacity:1; transform:translateY(0); }
        }
        .scrollbar-hide::-webkit-scrollbar { display:none; }
        .scrollbar-hide { -ms-overflow-style:none; scrollbar-width:none; }
      `}</style>
    </div>
  );
};

export default BlogPage;
